import React from "react";
import {useTranslation} from "react-i18next";
import {Grid, ListItem, ListItemIcon, ListItemText, Paper, Typography} from "@material-ui/core";
import List from "@material-ui/core/List";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import Loader from "../core/Loader";
import withWidth, {WithWidthProps} from "@material-ui/core/withWidth";
import {IShipment} from "../core/shipments/ShipmentList";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1,
        },
        grid: {
            "& .MuiGrid-item": {
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                flexDirection: "column"
            }
        },
        lineItemContextContainer: {
            display: "flex",
            flex: 1,
            justifyContent: "space-between",
            alignItems: "center"
        },
        shipmentInfoContainer: {
            display: "flex",
            alignItems: "center",
            flex: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
        shipmentInfoCard: {
            flex: 1
        },
        caption: {
            fontWeight: "bold",
            marginRight: 5
        },
        value: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: '11rem'
        },
        modality: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            "& img": {
                height: 40
            }
        },
    }),
);


interface IPublicTrackingShipmentInfoCard {
    shipment?: IShipment
}


const PublicTrackingShipmentInfoCard: React.FC<IPublicTrackingShipmentInfoCard & WithWidthProps> = ({
                                                                                                        shipment,
                                                                                                        width
                                                                                                    }) => {
    const classes = useStyles();
    const {t} = useTranslation();


    return <Paper className={classes.root}>
        <List>
            <ListItem>
                <ListItemIcon>
                    <div className={classes.modality}>
                        <img src={`/assets/icons/modalities/${shipment?.modality.toLowerCase()}.png`}
                             alt={shipment?.modality}/>
                        <Typography variant="caption">{t("core.modality." + shipment?.modality)}</Typography>
                    </div>
                </ListItemIcon>
                <ListItemText
                    primary={<CardItem shipment={shipment} width={width}/>}
                />
            </ListItem>

        </List>
    </Paper>
};


const CardItem: React.FC<IPublicTrackingShipmentInfoCard & WithWidthProps> = ({shipment, width}) => {

    const {t} = useTranslation();

    if (!shipment) {
        return <Loader/>;
    }

    const {shipper, consignee, reference, status} = shipment;


    return <React.Fragment>
        <Grid container justifyContent="center"
              alignItems="center">

            <Grid item xs={12} sm={6}>
                <InfoCardLine property={t("shipment.status")} value={t("shipment.tracking-status-range." + status)}
                              width={width}/>
                <InfoCardLine property={t("shipment.reference")} value={reference} width={width}/>
            </Grid>

            <Grid item xs={12} sm={6}>
                <InfoCardLine property={t("shipment.shipper-country")} value={shipper} width={width}/>
                <InfoCardLine property={t("shipment.consignee-country")} value={consignee} width={width}/>
            </Grid>


        </Grid>

    </React.Fragment>
};

export const InfoCardLine: React.FC<{ property?: string, value?: string } & WithWidthProps> = ({
                                                                                                                                                                                                           property,
                                                                                                                                                                                                           value,
                                                                                                                                                                                                           width
                                                                                                                                                                                                       }) => {

    const classes = useStyles();

    return <div className={classes.shipmentInfoContainer}
                style={{width: width === "xs" ? '12rem' : '25rem'}}
    >
        {property && <Typography
            variant="body1"
            color="textPrimary"
            className={classes.caption}
        >
            {property}:
        </Typography>}
        <Typography
            noWrap={true}
            variant="body2"
            color="textPrimary"
        >
            {value}
        </Typography>
    </div>
};


export default withWidth()(PublicTrackingShipmentInfoCard);
